'use strict'

import ApiClient from './ApiClient'

export default class LicenseSettingRepository {
  /**
   * ライセンス情報の取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/licenses`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/LicenseSettingRepository.js